<template>
  <section>
    <div class="article">
        <h1 class="article_title">「{{ article.title }}」は英語で何と言うの？</h1>
        <hr style="margin-top:8px;">
        <!-- <p>投稿日：{{ modifyDatetime(article.createdAt) }}</p> -->
        <span>【回答】</span><div class="article_content" v-html="article.content"></div>
<router-link to="/">
<div class="card">
  <div class="card-content">
    <div class="media">
      <div class="media-left">
        <figure class="image  is-64x64">
          <img src="https://translate.ameneko.com/translateIcon.png" alt="image">
        </figure>
      </div>
      <div class="media-content">
        <p class="title is-5">メモや日記ついでに英語学習 -メモ英-</p>
      </div>
    </div>
    <div class="content">
      あなたの書いたメモや日記を英語に翻訳するアプリです。メモや日記ついでに英語学習ができます。
    </div>
  </div>
</div>
</router-link>
        <br>
        <router-link to="/articles">メモ英マガジン一覧へ</router-link>
    </div>
  <AdComponent />
  </section>
</template>

<script>
import axios from "axios";
import moment from 'moment'
import AdComponent from  './../components/AdComponent.vue'
export default {
      components:{
        AdComponent
    },
  data() {
    return {
      article: null
    };
  },
  mounted() {
    this.fetchNotice();
  },
  methods: {
    fetchNotice() {
        let url = "https://translate.microcms.io/api/v1/article/" + this.$route.params.id
        axios
            .get(url, {
            headers: { "X-API-KEY": process.env.VUE_APP_MICRO_CMS }
            })
            .then(res => {
            this.article = res.data
            }).then(()=>{
                const title = "「" + this.article.title + "」" + "は英語で何と言うの？｜メモや日記ついでに英語学習"
                const description = "「" + this.article.title + "」" + "は英語で何と言うの？【回答】" + this.article.content.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'') 
                document.title = title
                document.querySelector("meta[property='og:title']").setAttribute('content', title)
                document.querySelector("meta[name='description']").setAttribute('content', description)
                document.querySelector("meta[property='og:description']").setAttribute('content', description)
            })
            .catch(err => {
            console.log(err);
        });
    },
    // modifyDatetime(date) {
    //   return moment(date).locale('ja').format('LLL')
    // }
  },
};
</script>

<style scoped>
.article{
  max-width: 600px;
  margin: auto;
  padding:20px;
}
.card-content{
  margin-top: 20px;
  padding: 8px;
}
h2{
  font-weight: bold;
  font-size: 1.2em;
  text-align: center;
  padding-bottom: 10px;
}
div >>> h1{
  font-weight: bold;
  font-size: 1.3em;
  padding-bottom: 10px;
}
div >>> h3{
  font-weight: bold;
  font-size: 1.2em;
  padding-top: 10px;
  padding-bottom: 10px;
}
div >>> p{
  padding: 10px;
  font-size:1.1em;
}


</style>